const colors = {
  green: "#41B878", // 0 green
  teal: "#0F4852", // 1 teal
  darkBlue: "#0F242C", // 2 dark blue
  lemon: "#E9ED9A", // 3 lemon
  cream: "#F4F7DE", // 4 cream
}

export default colors
